import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm255-252H185v173h255v-173Zm80 0v173h255v-173H520Zm-80-80v-173H185v173h255Zm80 0h255v-173H520v173ZM185-690h590v-85H185v85Z"/>',
  f: '<path d="M450-333H106v148q0 33 23 56t56 23h265v-227Zm60 0v227h265q33 0 57-23t23-56v-148H510Zm-60-60v-228H106v228h344Zm60 0h345v-228H510v228ZM106-681h749v-94q0-33-23-57t-57-23H185q-33 0-56 23-23 24-23 57v94Z"/>',
};

export default data;
